<template>
  <v-container fluid pa-0 my-0 id="footer">
    <v-layout align-center px-5 py-3 justify-center row fill-height class="footer-body" style="background-color: var(--v-primary-base);">
      <v-flex v-html="footer_left"></v-flex>
      <v-flex v-html="footer_right"></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "rFooter",
  props: {
    footer_left: null,
    footer_right: null
  }
};
</script>

<style scoped>
  .footer-body{
    color: white;
  }
</style>
